<template>
  <div class="yh_detail_bd">
    <p class="crumbs">
      <span>
        您的位置 :
        <router-link to="/Index">首页</router-link>>
        <span @click="$router.back(-1)" class="pointer">评奖成果库</span> >
        <a>正文</a>
      </span>
    </p>
    <div class="details_main_box">
      <section class="book_msg">
        <div class="left img_box">
          <img src="http://localhost:8080/static/img/book/1.png" alt>
        </div>
        <div class="left book_msg_center">
          <h5 class="artical_name">{{artical.name}}</h5>
          <p class="artical_author" style="margin-bottom: 6px;">申报者 ：{{artical.author}}</p>
          <p class="award_msg">成果类型 ：{{GetTypeName(artical.categoryId)}}</p>

          <p class="award_msg">成果属性 ：{{GetLevelName(artical.property)}}</p>
          <p class="award_msg">成果期次 ：{{artical.vol}}</p>
          <p class="award_msg">获得奖项 : {{artical.award}}</p>
          <p class="award_msg">阅读 : {{artical.visits}}</p>
        </div>
        <div class="right">
          <el-button
            type="primary"
            size="small"
            style="width: 100px;margin-top:98px;position: absolute;bottom: 20px;right: 20px;"
            @click="to_read_fn(0)"
          >阅读</el-button>
        </div>
      </section>
      <h4 class="artical_tit_h">图书简介</h4>
      <section class="artical_intro" v-if="artical.brief != undefined">{{artical.brief}}</section>
      <section class="no_data_" v-else>暂无数据</section>
      <h4 class="artical_tit_h">作者简介</h4>
      <section class="artical_intro" v-if="artical.author_profile != undefined">
        <div class="left img_box">
          <img src="http://localhost:8080/static/img/book/1.png" alt>
        </div>
        <div class="left book_msg_center author_profile">{{artical.author_profile}}</div>
      </section>
      <section class="no_data_" v-else>暂无数据</section>
      <h4 class="artical_tit_h">章节目录</h4>

      <section class="artical_catalog" v-if="artical.catalogue != ''">
        <!-- <p v-for=" x in (artical.catalogue)"> -->
        <span class="pointer" @click="to_read_fn">{{artical.catalogue}}</span>
        <!-- </p> -->
      </section>
      <section class="no_data_" v-else>暂无数据</section>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/utils";
export default {
  data() {
    return {
      currentArticle: {},
      artical: {
        if_collect: false,
        author: "",
        category_id: "",
        property: "",
        vol: "",
        award: "",
        visits: "",
        brief: "",
        author_profile: "",
        artical_intro: "",
        catalogue: [""]
      }
    };
  },
  methods: {
    collect_fn(id) {
      this.artical.if_collect = !this.artical.if_collect;
      var obj = {
        if_collect: this.artical.if_collect,
        id: this.artical.id
      };
      //  		  this.$api.axios_collect(obj).then(res => {
      //    	      this.artical = res.data;
      // 				})
    },
    to_read_fn() {
     sessionStorage.setItem("article",JSON.stringify(this.artical))
     sessionStorage.setItem("articleType",1)
      this.$router.push({
        path: "/readOnLine"
      });
    },
        // 获取类型名称
    GetTypeName: utils.GetAwardTypeName,
    // 获取级别名称
    GetLevelName: utils.GetAwardProperty
  },
  mounted() {
    this.$api.axios_award_detail("/" + this.$route.query.id).then(res => {
      if (res.status === "OK") {
        this.artical = res.result.items[0];
        this.artical.categoryId = this.getAwardType(this.artical.categoryId)
        this.artical.property = this.getAwardProperty(this.artical.property)
      }else if(res.status==="FAIL"){
            if(res.errors[0].code === 1014){
          this.$message.error("登录过期，请重新登录");
          this.$router.push({ path: "/login" });
        }
        else if(res.errors[0].code === 1017){
          this.$message.error("您的账号已在其他地方登录，若不是本人操作，请注意账号安全");
          this.$router.push({ path: "/login" });
        }
        else{
          this.$message.error("数据请求错误");
        }
          }
    });
  },
  created: function() {
    if (localStorage.getItem("doc_token") == null) {
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../../assets/css/details");
</style>


// WEBPACK FOOTER //
// src/components/detail/award_details.vue